import type { FullscreenPort } from '@Domain/Ports/Fullscreen/FullscreenPort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useFullscreenPort(): FullscreenPort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useFullscreenPort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.fullscreen;
}

export default useFullscreenPort;
